import { getOS } from './get_os';

export function getPlatformPath(path: string | undefined) {
  if (path === undefined) {
    return undefined;
  }
  return getOS() === 'Windows' ? path.replace(/\//g, '\\') : path;
}
